<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <!-- Header -->
    <layout-header />
    <!-- /Header -->

    <!-- Breadcrumb -->
    <!-- /Breadcrumb -->

    <!-- Page Content -->
    <div class="content success-page-cont">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <!-- Success Card -->
            <div class="card success-card">
              <div class="card-body">
                <div class="success-cont">
                  <i class="fas fa-check"></i>
                  <h3>Réservation Échouée!</h3>
                  <h4>Désolé! Votre paiement n'a pas été traité avec succès.</h4>
                  <hr>
                  <p>
                    Cliquez <a :href="'/fields/' + booking.slot.field.id + '?date=' + formatDate(booking.start_time, 'YYYY-MM-DD')"><b>ici</b></a> si vous voulez essayer à nouveau.
                  </p>

                  <div class="avatar avatar-lg border-sm">
                    <img class="avatar-img" :src="'/api/static/' + booking.slot.field.stadium.stadium_logo + '.jpg'" alt="Stadium Logo">
                  </div>
                  <h5 class="text-primary mt-1 mb-0"><b>{{ booking.slot.field.stadium.business_name }}</b></h5>
                  <h5 class="mb-2">{{ booking.slot.field.name }}</h5>
                  <p class="mb-1">
                    <span class="fas fa-map-marker-alt text-primary mr-1"></span> {{ booking.slot.field.stadium.state }}, TN
                  </p>
                  <p class="mb-1">
                    <span class="far fa-calendar-alt text-primary mr-1"></span> {{ formatDate(booking.start_time) }}
                  </p>
                  <p class="mb-4">
                    <span class="far fa-clock text-primary mr-1"></span> {{ formatDate(booking.start_time, 'HH:mm') }} - {{ formatDate(booking.end_time, 'HH:mm') }}
                  </p>
                </div>
              </div>
            </div>
            <!-- /Success Card -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- Footer -->
    <layout-footer />
    <!-- /Footer -->
  </div>
</template>
<script>
import { api } from "@/store";
export default {
  props: ['id'],
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
  },
  data() {
    return {
      booking: {},
    }
  },
  created() {
    this.getBooking()
  },
  methods: {
    async getBooking() {
      return await api.get('/my/bookings/' + this.id)
        .then(response => {
          const result = response.data
          this.booking = result
          if (this.booking.status == 'confirmed') 
            window.location.replace("/booking/" + this.id + '/success')
        })
    },
    formatDate(date, format = 'LL') {
      if (date) {
        date.replace('T', ' ').replace('.000000Z', '')
        return moment(String(date)).format(format)
      }
    },
  },
};
</script>
